// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"705":"47c4e9a3","925":"ed12f9c6"}[chunkId] + ".chunk.js";
};